import css from "./FadeOutFadeIn.module.scss";

import React, { useRef } from "react";
import {
  CSSTransition,
  SwitchTransition,
} from "react-transition-group";

import "./FadeOutFadeIn.scss";
import { BasePropsWithChildren } from "../../BaseProps";
import { classNames } from "@greeter/util";

export type FadeOutFadeInProps = BasePropsWithChildren & {
  transitionKey?: any;
  transition?: string;
}

export function FadeOutFadeIn({
  transitionKey,
  className,
  ...props
}: FadeOutFadeInProps) {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        mountOnEnter
        unmountOnExit
        key={transitionKey}
        timeout={50}
        classNames="fade"
        nodeRef={ref}
      >
        <div ref={ref} {...classNames(css.FadeOutFadeIn, className)} {...props} />
      </CSSTransition>
    </SwitchTransition>
  );
};
